"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ChatPreview = require("./ChatPreview");
Object.keys(_ChatPreview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChatPreview[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ChatPreview[key];
    }
  });
});